/*
 * Copyright (c) 2022. Haodong JU
 */

// import GlobalSettings from '@/GlobalSettings'
import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import GlobalSettings from '@/GlobalSettings'
import PrintNameEntity from '@/model/buffet/PrintNameEntity'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    formConfig: {
      requiredNew: false,
    },
    form: false,
    header: false,
  },

  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'name',
      default: GlobalSettings.supportLang,
      childLabelKey: 'lang',
      type: {},
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toUpperCase() === GlobalSettings.getLang()
      },
      displayChild: (key) => {
        return key === 'name'
      },
    },
    childKey: ['name', 'printName'],
    labelKey: 'lang',
    children: [
      PrintNameEntity, PrintNameEntity, PrintNameEntity,
    ],
  },
  color: {
    displayName: ' ',
    tableConfig: {
      width: '60px',
    },
    type: IKDataEntity.Types.Color,
  },
  zbonGroup: {
    displayName: 'zbonGroup',
    formConfig: {
      default: 100,
      required: false,
    },
    header: false,
    form: false,
  },

}
const config = {
  load: async function (filter) {
    const response = (await hillo.get('Complex.php', {
      op: 'showAllConsumeTypeInfo',
      lang: GlobalSettings.getLang(),
      ...filter,
    }))
      .content
    response.forEach(i => {
      i.langs = Object.values(i.langs)
      i.name = i.langs.find(it => it.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase())?.name ?? i.name
    })
    return response.filter(it => it.printName !== 'Bargeldbuchhaltung' && !['3', '4'].includes(it.id))
  },
  add: function (item) {
    item.name = item.langs[2].name
    item.zbonGroup = 100
    return hillo.post('ConsumeType.php?op=add', {
      ...item,
      langs: JSON.stringify(item.langs),
    }, {
      showLoading: false,
    })
  },
  edit: function (item) {
    item.name = item.langs[2].name
    return hillo.postWithUploadFile('ConsumeType.php?op=update', {
      ...item,
      langs: JSON.stringify(item.langs),
    }, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post('ConsumeType.php?op=delete', { id: id })
  },
}

export default IKDataEntity.ModelFactory(entity, config)

